import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import OfficeSupplyOrderDetails from '@/types/table/officeSupplyOrderDetails';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface OfficeSupplyOrderDetailsData extends OfficeSupplyOrderDetails {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class OfficeSupplyOrderDetailsController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<OfficeSupplyOrderDetailsData>>(API_CONTEXT + '/office/officeSupplyOrderDetails/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<OfficeSupplyOrderDetailsData>(API_CONTEXT + '/office/officeSupplyOrderDetails/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/office/officeSupplyOrderDetails/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/office/officeSupplyOrderDetails/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/office/officeSupplyOrderDetails/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrderDetails/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrderDetails/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrderDetails/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrderDetails/deleteBatch', params, httpOptions);
  }
}
